/**
 * Sortable.js 플러그인
 * 프로덕션 빌드에서 동적 import 문제를 해결하기 위한 글로벌 플러그인
 */
import Sortable, { MultiDrag } from 'sortablejs';

// 다중 카드 선택/드래그를 위한 MultiDrag 플러그인 활성화
// (AutoScroll 플러그인은 sortablejs ESM 빌드에 이미 자동 마운트되어 있어 별도 등록 불필요.
//  드래그 중 가장자리 자동 스크롤은 CategoryCard 의 Sortable scroll 옵션으로 활성화)
Sortable.mount(new MultiDrag());

export default defineNuxtPlugin(() => {
  return {
    provide: {
      Sortable,
    },
  };
});
